/**
 * PaperPanelRegistry (P1-S1) — cầu nối panel đáy multi tới broker của ô active.
 * Mỗi TradingProvider có chartId tự đăng ký binding; panel đọc theo activeChartId.
 * Có subscribe cấp registry (D8) chống kẹt rỗng khi lệch mount.
 */
import { useSyncExternalStore } from "react";
const bindings = new Map();
const registryListeners = new Map();
const registryVersion = new Map();
function notifyRegistry(chartId) {
    registryVersion.set(chartId, (registryVersion.get(chartId) ?? 0) + 1);
    registryListeners.get(chartId)?.forEach((fn) => {
        try {
            fn();
        }
        catch {
            // Listener lỗi không chặn các listener khác.
        }
    });
}
export function registerPaperPanelBinding(binding) {
    bindings.set(binding.chartId, binding);
    notifyRegistry(binding.chartId);
}
export function unregisterPaperPanelBinding(chartId) {
    if (bindings.delete(chartId))
        notifyRegistry(chartId);
}
export function getPaperPanelBinding(chartId) {
    if (!chartId)
        return undefined;
    return bindings.get(chartId);
}
export function subscribePaperPanelRegistry(chartId, listener) {
    if (!chartId)
        return () => { };
    let set = registryListeners.get(chartId);
    if (!set) {
        set = new Set();
        registryListeners.set(chartId, set);
    }
    set.add(listener);
    return () => {
        set.delete(listener);
    };
}
/** Re-render khi binding đến/mất (late registration) — D8, không bao giờ kẹt rỗng. */
export function usePaperPanelBinding(chartId) {
    useSyncExternalStore((fn) => subscribePaperPanelRegistry(chartId, fn), () => registryVersion.get(chartId ?? "") ?? 0, () => 0);
    return getPaperPanelBinding(chartId);
}
/** Xóa toàn bộ binding giữa các test (chống rò Map — Finding-06). */
export function clearAllPaperPanelBindingsForTesting() {
    bindings.clear();
    registryListeners.clear();
    registryVersion.clear();
}
